import { createFileRoute, useRouteContext } from '@tanstack/react-router';

import { useGetOrganizationAnalytics } from '../../../api/generated/api';
import { AnalyticsPage, organizationAnalyticsCatalogGroups } from '../../../modules/analytics';
import { dateRangeSearchSchema, resolveDateRange } from '../../../ui/components/date-range-filter';
import { useNavigationPosition } from '../../../ui/hooks';

const AnalyticsRoute = () => {
  const navigate = Route.useNavigate();
  const search = Route.useSearch();

  const { selectedOrganization } = useRouteContext({ from: '/_authenticated/_app' });
  const { from, to } = resolveDateRange(search);
  const { isSideNav } = useNavigationPosition();

  const { data, isPending, isFetching, error } = useGetOrganizationAnalytics(
    selectedOrganization.id,
    { from: from.startOf('day').toISOString(), to: to.endOf('day').toISOString() },
  );

  return (
    <AnalyticsPage
      storageKey="k3x.analytics.organization"
      catalogGroups={organizationAnalyticsCatalogGroups}
      defaultMetricIds={['crm-leads', 'crm-emails', 'crm-calls', 'crm-deals', 'crm-contacts']}
      metricsById={data?.data.metrics ?? {}}
      loading={data ? isFetching : isPending}
      error={error}
      search={search}
      onSearchChange={(nextSearch) => navigate({ search: nextSearch })}
      hasSidebarGutter={isSideNav}
      organizationId={selectedOrganization.id}
    />
  );
};

export const Route = createFileRoute('/_authenticated/_app/analytics')({
  component: AnalyticsRoute,
  validateSearch: dateRangeSearchSchema,
});
